<template>
  <v-container fluid fill-height class="pa-2">
    <v-row style="height: 100%;">
      <v-col
        v-for="item in filteredDevices"
        :key="item.id"
        xs=12
        sm=6
        md=6
        lg=4
        xl=3
        align="center"
      >
        <DeviceCard :item="item"></DeviceCard>
      </v-col>
      <v-col
      xs=12
      sm=6
      md=6
      lg=4
      xl=3
      align="center"
      >
        <v-card
          width="350"
          height="260"
          hover
          :to="{ name: 'AddDevice', params: { type: deviceType } }"
          class="pt-12"
        >
          <v-img max-width="85" src="/add_camera.png"></v-img>
          <v-card-title class="mt-8 justify-center">Add new device</v-card-title>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import gql from 'graphql-tag';
import DeviceCard from '@/components/Home/DeviceCard.vue';

const SUBSCRIPTION_DEVICES = gql`
subscription get_devices {
  devices {
    id
    name
    serial
    firmware
    code
    description
    mode
    timelapse_interval
    onsite_session_url
    type
  }
}
`;

export default {
  name: 'Home',
  props: {
    type: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      devices: [],
    };
  },
  created() {
  },
  beforeDestroy() {
  },
  components: {
    DeviceCard,
  },
  computed: {
    deviceType() {
      return (this.type || 'camera');
    },
    filteredDevices() {
      return this.devices.filter((el) => el.type === this.deviceType);
    },
  },
  apollo: {
    // Subscriptions
    $subscribe: {
      // When a user is added
      devices: {
        query: SUBSCRIPTION_DEVICES,
        // Result hook
        result(data) {
          // Let's update the local data
          this.$store.commit('devices', data.data.devices);
          this.devices = data.data.devices;
        },
      },
    },
  },
};
</script>

<style scoped>
</style>
